// Generated by CoffeeScript 1.9.1
module.exports.defaultmenu = require("./defaultmenu");
module.exports.menubuilder = require("./menubuilder");